import { render, staticRenderFns } from "./HostInPerson.vue?vue&type=template&id=2e04d482&scoped=true&"
var script = {}
import style0 from "./HostInPerson.vue?vue&type=style&index=0&id=2e04d482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e04d482",
  null
  
)

export default component.exports